import React, { useState, useEffect } from 'react'
import {
  FlexboxGrid,
  Grid,
  Row,
  Col,
  Panel,
  Table,
  SelectPicker,
  InputGroup,
  InputNumber,
  RangeSlider,
  CheckPicker,
  CheckTreePicker,
  Button,
  Icon,
} from 'rsuite'
import TopLevelNav from '../../../components/TopLevelNav'
import PageToolbar from '../../../components/PageToolbar'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import PanalLoadingTemplate from '../../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { doneLoading, startLoading } from '../../../utils/loading'
import ErrorWidget from '../../errorWidget/ErrorWidget'
import './styles.css'
import DoughnutChart from '../charts/echartWidgets/DoughnutChart'
import GeoChoroplethAndScatter from '../charts/echartWidgets/GeoChoroplethAndScatter'
import BasicBarChart from '../charts/echartWidgets/BasicBarChart'
import BasicLineChart from '../charts/echartWidgets/BasicLineChart'
import { Controller, useForm } from 'react-hook-form'
import {
  getProjectsDevelopment,
  searchProjectsDevelopment,
} from '../../../redux/actions/dashboardDep6'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function ProjectsDevelopment() {
  const { register, handleSubmit, errors, control, reset, clearErrors } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [response, setResponse] = useState()

  const [value, setValue] = React.useState([1, 1000000])
  const [chartMapOption, setChartMapOption] = useState()
  const [mapData, setMapData] = useState(null)
  const [loading, setLoading] = useState(true)

  const [schema, setSchema] = useState()

  const [sortColumn, setSortColumn] = useState()
  const [sortType, setSortType] = useState()
  const [isLoadingTable, setIsLoadingTable] = useState(false)

  const [trainingAttendanceFrequency, setTrainingAttendanceFrequency] = useState()
  const [nodeId, setNodeId] = useState()
  const [levelUserstandingKnowledge, setLevelUserstandingKnowledge] = useState()
  const [overviewSelfAssessmentScores, setOverviewSelfAssessmentScores] = useState()
  const [projectAreaId, setProjectAreaId] = useState()
  const [projectCode, setProjectCode] = useState()

  const [evaluation, setEvaluation] = useState()
  const [locationProvince, setLocationProvince] = useState()
  const [traningPd, setTraningPd] = useState()
  const [criOrderBy, setCriOrderBy] = useState()

  const { Column, HeaderCell, Cell, Pagination } = Table

  const _styles = {
    panel: {
      backgroundColor: '#34a888',
    },
    titleMesage: {
      color: '#ffffff',
    },
    content: {
      marginTop: 20,
    },
    icon: {
      paddingRight: 10,
    },
    footer: {
      marginTop: 15,
    },
    button: {
      width: 120,
      color: '#ffffff',
      backgroundColor: '#575757',
      fontWeight: 'bold',
      fontSize: '14 !important',
    },
  }

  const mockSchema = {
    forms: {
      header: 'ข้อมูลผลประเมินเรื่องพัฒนาข้อเสนอโครงการสร้างเสริมสุขภาพ (Project Development: PD)',
      dashboardInfo: {
        trainingAttendanceFrequency: {
          title: 'ข้อมูลความถี่ของการเข้าร่วมอบรม',
          setting: {
            seriesData: [
              { value: 18.42, name: 'เคย 1 ครั้ง' },
              { value: 34.21, name: 'เคย 2 - 3 ครั้ง' },
              { value: 21.05, name: 'เคยมากกว่า 3 ครั้ง' },
              { value: 26.32, name: 'ไม่เคย' },
            ],
          },
        },
        evaluationResultsClassified: {
          title: 'ข้อมูลผลการประเมิน จำแนกตามประเภททีมประเมินหน่วยจัดการ',
          setting: {
            xAxisData: [
              'N5 = Node เด็กและเยาวชน ระดับปานกลาง',
              'N1 = Node จังหวัด',
              'N5 = Node เด็กและเยาวชน',
              'N1 = Node จังหวัด',
              'N2 = Node Flagship',
              'N3 = แผนงานร่วมทุน ระดับมากที่สุด',
              'N5 = Node เด็กและเยาวชน',
              'อื่นๆ',
            ],
            seriesData: [1, 1, 2, 1, 1, 2, 2, 1],
            barColor: '#96d897',
            axisLabelConfig: {
              interval: 0, // แสดง label ทุกรายการ
              rotate: 10, // หมุน label 45 องศา
              fontSize: 10, // ขนาดตัวอักษร
              margin: 10, // ระยะห่างจาก axis
            },
            yAxisName: 'จำนวนภาคี',
            xAxisName: 'ประเภททีมประเมิน',
            xNameLocation: 'middle',
            xNameGap: 40,
          },
        },
        levelUserstandingKnowledge: {
          title: 'ระดับความเข้าใจชุดความรู้เรื่องการพัฒนาข้อเสนอโครงการ',
          setting: {
            xAxisData: ['ระดับปานกลาง', 'ระดับมาก', 'ระดับมากที่สุด'],
            seriesData: [1, 6, 31],
            barColor: '#dda5f7',
            yAxisName: 'จำนวนภาคี',
            xAxisName: 'ระดับผลคะแนน',
            xNameLocation: 'middle',
            xNameGap: 30,
          },
        },
        overviewSelfAssessmentScores: {
          title: 'ภาพรวมคะแนนประเมินตนเองด้านพัฒนาข้อเสนอโครงการสร้างเสริมสุขภาพ',
          setting: {
            xAxisData: ['ระดับ 1', 'ระดับ 2', 'ระดับ 3', 'ระดับ 4', 'ระดับ 5'],
            seriesData: [0, 3, 11, 14, 17],
            barColor: '#dda5f7',
            yAxisName: 'จำนวนภาคี',
            xAxisName: 'ระดับผลคะแนน (ประเมินตนเอง)',
            xNameLocation: 'middle',
            xNameGap: 30,
          },
        },
        numberProjectArea: {
          title: 'จำนวนโครงการรายพื้นที่',
          setting: {
            seriesData: [
              {
                name: 'เชียงใหม่',
                value: 149,
              },
              {
                name: 'เชียงราย',
                value: 675,
              },
            ],
          },
        },
        projectDetail: {
          title: 'รายละเอียดโครงการ',
          values: [
            {
              projectCoe: '68-00278',
              fullName: 'กนกพร พรมจันทร์',
              resultPd: 'ระดับ มาที่สุด',
              levelPd: 'ระดับ 5',
              score: 'ไม่เคย',
            },
            {
              projectCoe: '68-00279',
              fullName: 'อนุพงษ์ ชำนาญกุล',
              resultPd: 'ระดับ มาก',
              levelPd: 'ระดับ 4',
              score: 'ไม่เคย',
            },
          ],
        },
      },
      searchForms: {
        evaluation: {
          name: 'evaluation',
          label: 'เกณฑ์การประเมิน',
          value: '',
          options: [
            { disabled: false, label: 'ระดับ ปรับปรุง', value: '1' },
            { disabled: false, label: 'ระดับ น้อย', value: '2' },
            { disabled: false, label: 'ระดับ ปลานกลาง', value: '3' },
          ],
        },
        province: {
          name: 'province',
          label: 'จังหวัด',
          options: [
            { disabled: false, label: 'เชียงราย', value: '1' },
            { disabled: false, label: 'เชียงใหม่', value: '2' },
            { disabled: false, label: 'กรุงเทพมหานคร', value: '3' },
          ],
        },
        traningPd: {
          name: 'traningAre',
          label: 'เข้าร่วมอบรม ARE',
          value: '',
          options: [
            { disabled: false, label: 'เคย 1 ครั้ง', value: '1' },
            { disabled: false, label: 'เคย 2 - 3 ครั้ง', value: '2' },
            { disabled: false, label: 'เคย มากกว่า 3 ครั้ง', value: '3' },
          ],
        },
        button: {
          search: {
            setCol: { xxs: 24, xsm: 24, xmd: 24, xlg: 12 },
            label: 'ค้นหา',
          },
          cancel: {
            setCol: { xxs: 24, xsm: 24, xmd: 24, xlg: 24 },
            label: 'ยกเลิก',
          },
          exportExcel: {
            setCol: { xxs: 24, xsm: 24, xmd: 24, xlg: 12 },
            label: 'Download Excel',
          },
        },
      },
    },
  }

  useEffect(() => {
    // console.log('load ref ID => ', referenceID)

    handleGetResponse()
  }, [])

  const handleGetResponse = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const res = await getProjectsDevelopment()
      console.log('res => ', res)

      setSchema(res.forms)
      // setSchema(mockSchema.forms)
    } catch (e) {
      console.log('error => ', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSortColumn = (sortColumn, sortType) => {
    console.log('handleSortColumn => ', sortColumn, sortType)
    setIsLoadingTable(true)

    handleClickSearch('criOrderBy', `${sortColumn}_${sortType}`)

    setTimeout(() => {
      setSortColumn(sortColumn)
      setSortType(sortType)
      setIsLoadingTable(false)
    }, 500)
  }

  const handleExportExcel = () => {
    alert('handleExportExcel')
  }

  const callApiSearch = async (req) => {
    setIsLoading(true)
    startLoading()

    try {
      var response = await searchProjectsDevelopment(req)
      console.log('resssss => ', response)
      setSchema(response.forms)
    } catch (e) {
      console.log('error => ', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleCancel = () => {
    setTrainingAttendanceFrequency()
    setNodeId()
    setLevelUserstandingKnowledge()
    setOverviewSelfAssessmentScores()
    setProjectAreaId()
    setProjectCode()
    setEvaluation()
    setLocationProvince()
    setTraningPd()
    setCriOrderBy()

    handleGetResponse()
  }

  const handleSearch = async () => {
    const req = {
      trainingAttendanceFrequency: trainingAttendanceFrequency || '',
      nodeId: nodeId || '',
      levelUserstandingKnowledge: levelUserstandingKnowledge || '',
      overviewSelfAssessmentScores: overviewSelfAssessmentScores || '',
      projectAreaId: projectAreaId || '',
      projectCode: projectCode || '',
      evaluation: evaluation || '',
      locationProvince: locationProvince?.length > 0 ? locationProvince.toString() : '',
      traningPd: traningPd?.length > 0 ? traningPd.toString() : '',
      criOrderBy: criOrderBy?.length > 0 ? criOrderBy.toString() : '',
    }

    await callApiSearch(req)
  }

  const handleClickSearch = async (ctype = null, cid = null) => {
    const req = {
      trainingAttendanceFrequency:
        ctype == 'trainingAttendanceFrequency' ? cid || '' : trainingAttendanceFrequency || '',
      nodeId: ctype == 'node' ? cid || '' : nodeId || '',
      levelUserstandingKnowledge:
        ctype == 'levelUserstandingKnowledge' ? cid || '' : levelUserstandingKnowledge || '',
      overviewSelfAssessmentScores:
        ctype == 'overviewSelfAssessmentScores' ? cid || '' : overviewSelfAssessmentScores || '',
      projectAreaId: ctype == 'projectArea' ? cid || '' : projectAreaId || '',
      projectCode: ctype == 'projectCode' ? cid || '' : projectCode || '',
      evaluation: evaluation || '',
      locationProvince: locationProvince?.length > 0 ? locationProvince.toString() : '',
      traningPd: traningPd?.length > 0 ? traningPd.toString() : '',
      criOrderBy: ctype == 'criOrderBy' ? cid || '' : criOrderBy || '',
    }

    switch (ctype) {
      case 'trainingAttendanceFrequency':
        setTrainingAttendanceFrequency(cid)
        break

      case 'node':
        setNodeId(cid)
        break

      case 'levelUserstandingKnowledge':
        setLevelUserstandingKnowledge(cid)
        break

      case 'overviewSelfAssessmentScores':
        setOverviewSelfAssessmentScores(cid)
        break

      case 'projectArea':
        setProjectAreaId(cid)
        break

      case 'projectCode':
        setProjectCode(cid)
        break

      case 'criOrderBy':
        setCriOrderBy(cid)
        break

      default:
        break
    }

    await callApiSearch(req)
  }

  if (error) {
    return (
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <ErrorWidget statusCode={error?.statusCode} errorMessage={error?.errorMessage} />
        </Col>
      </Row>
    )
  }

  if (!schema || isLoading) {
    return (
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <OverlayLoader />
          <PanalLoadingTemplate />
        </Col>
      </Row>
    )
  }

  return (
    <>
      <div style={{ marginTop: 50, fontSize: 16 }}>
        {schema.header && (
          <Panel bordered bodyFill style={{ marginTop: 5 }}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} className="dashboard-header">
                <p className="dashboard-header-txt">{schema?.header || ''}</p>
              </Col>
            </Row>
          </Panel>
        )}

        {schema?.dashboardInfo && (
          <Row>
            <Col xs={24} sm={24} md={18} lg={18}>
              <Panel bordered collapsible defaultExpanded style={{ marginTop: 5 }} header={`  `}>
                <Row>
                  {schema?.dashboardInfo?.trainingAttendanceFrequency && (
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="title-view">
                        {schema?.dashboardInfo?.trainingAttendanceFrequency?.title}
                      </div>
                      <DoughnutChart
                        seriesData={
                          schema?.dashboardInfo?.trainingAttendanceFrequency?.setting?.seriesData ||
                          []
                        }
                        onClickCheart={(param) => {
                          handleClickSearch('trainingAttendanceFrequency', param.id)
                        }}
                      />
                    </Col>
                  )}

                  {schema?.dashboardInfo?.evaluationResultsClassified && (
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="title-view">
                        {schema?.dashboardInfo?.evaluationResultsClassified?.title || ''}
                      </div>
                      <BasicBarChart
                        xAxisData={
                          schema?.dashboardInfo?.evaluationResultsClassified?.setting?.xAxisData ||
                          []
                        }
                        seriesData={
                          schema?.dashboardInfo?.evaluationResultsClassified?.setting?.seriesData ||
                          []
                        }
                        barColor={
                          schema?.dashboardInfo?.evaluationResultsClassified?.setting?.barColor ||
                          ''
                        }
                        axisLabelConfig={
                          schema?.dashboardInfo?.evaluationResultsClassified?.setting
                            ?.axisLabelConfig || ''
                        }
                        yAxisName={
                          schema?.dashboardInfo?.evaluationResultsClassified?.setting?.yAxisName ||
                          ''
                        }
                        xAxisName={
                          schema?.dashboardInfo?.evaluationResultsClassified?.setting?.xAxisName ||
                          ''
                        }
                        xNameLocation={
                          schema?.dashboardInfo?.evaluationResultsClassified?.setting
                            ?.xNameLocation || ''
                        }
                        xNameGap={
                          schema?.dashboardInfo?.evaluationResultsClassified?.setting?.xNameGap ||
                          ''
                        }
                        onClickCheart={(param) => {
                          handleClickSearch('node', param.id)
                        }}
                      />
                    </Col>
                  )}

                  {schema?.dashboardInfo?.levelUserstandingKnowledge && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <div className="title-view">
                        {schema?.dashboardInfo?.levelUserstandingKnowledge?.title || ''}
                      </div>
                      <BasicBarChart
                        xAxisData={
                          schema?.dashboardInfo?.levelUserstandingKnowledge?.setting?.xAxisData ||
                          []
                        }
                        seriesData={
                          schema?.dashboardInfo?.levelUserstandingKnowledge?.setting?.seriesData ||
                          []
                        }
                        barColor={
                          schema?.dashboardInfo?.levelUserstandingKnowledge?.setting?.barColor || ''
                        }
                        yAxisName={
                          schema?.dashboardInfo?.levelUserstandingKnowledge?.setting?.yAxisName ||
                          ''
                        }
                        xAxisName={
                          schema?.dashboardInfo?.levelUserstandingKnowledge?.setting?.xAxisName ||
                          ''
                        }
                        xNameLocation={
                          schema?.dashboardInfo?.levelUserstandingKnowledge?.setting
                            ?.xNameLocation || ''
                        }
                        xNameGap={
                          schema?.dashboardInfo?.levelUserstandingKnowledge?.setting?.xNameGap || ''
                        }
                        onClickCheart={(param) => {
                          handleClickSearch('levelUserstandingKnowledge', param.id)
                        }}
                      />
                    </Col>
                  )}

                  {schema?.dashboardInfo?.overviewSelfAssessmentScores && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <div className="title-view">
                        {schema?.dashboardInfo?.overviewSelfAssessmentScores?.title || ''}
                      </div>
                      <BasicLineChart
                        xAxisData={
                          schema?.dashboardInfo?.overviewSelfAssessmentScores?.setting?.xAxisData ||
                          []
                        }
                        seriesData={
                          schema?.dashboardInfo?.overviewSelfAssessmentScores?.setting
                            ?.seriesData || []
                        }
                        barColor={
                          schema?.dashboardInfo?.overviewSelfAssessmentScores?.setting?.barColor ||
                          ''
                        }
                        yAxisName={
                          schema?.dashboardInfo?.overviewSelfAssessmentScores?.setting?.yAxisName ||
                          ''
                        }
                        xAxisName={
                          schema?.dashboardInfo?.overviewSelfAssessmentScores?.setting?.xAxisName ||
                          ''
                        }
                        xNameLocation={
                          schema?.dashboardInfo?.overviewSelfAssessmentScores?.setting
                            ?.xNameLocation || ''
                        }
                        xNameGap={
                          schema?.dashboardInfo?.overviewSelfAssessmentScores?.setting?.xNameGap ||
                          ''
                        }
                        onClickCheart={(param) => {
                          handleClickSearch('overviewSelfAssessmentScores', param.id)
                        }}
                      />
                    </Col>
                  )}

                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Row>
                      {schema?.dashboardInfo?.numberProjectArea && (
                        <Col xs={24} sm={24} md={6} lg={6}>
                          <Row>
                            <Col xs={24} sm={24} md={24} lg={24}>
                              <div className="title-view">
                                {schema?.dashboardInfo?.numberProjectArea?.title || ''}
                              </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24}>
                              <GeoChoroplethAndScatter
                                provinceDataFrom={
                                  schema?.dashboardInfo?.numberProjectArea?.setting?.seriesData
                                }
                                onClickCheart={(param) => {
                                  if (param && param[4]) {
                                    handleClickSearch('projectArea', param[4])
                                  }
                                }}
                              />
                            </Col>
                          </Row>
                        </Col>
                      )}

                      {schema?.dashboardInfo?.projectDetail && (
                        <Col xs={24} sm={24} md={18} lg={18}>
                          <Row>
                            <Col xs={24} sm={24} md={24} lg={24}>
                              <div className="title-view">
                                {schema?.dashboardInfo?.projectDetail?.title || ''}
                              </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24}>
                              <Table
                                height={420}
                                data={schema?.dashboardInfo?.projectDetail?.values || []}
                                wordWrap
                                sortColumn={sortColumn}
                                sortType={sortType}
                                onSortColumn={handleSortColumn}
                                loading={isLoadingTable}
                                onRowClick={(data) => {
                                  // console.log(data)
                                  handleClickSearch('projectCode', data?.projectCode)
                                }}
                                headerHeight={75}
                                className="table-data"
                              >
                                <Column width={150} align="center" fixed sortable>
                                  <HeaderCell>รหัสโครงการ</HeaderCell>
                                  <Cell dataKey="projectCode" />
                                </Column>

                                <Column width={200} sortable>
                                  <HeaderCell>ชื่อ-สกุล</HeaderCell>
                                  <Cell dataKey="fullName" />
                                </Column>

                                <Column width={180} sortable>
                                  <HeaderCell>ระดับผลคะแนน ด้าน PD</HeaderCell>
                                  <Cell dataKey="resultPd" />
                                </Column>

                                <Column width={180} sortable>
                                  <HeaderCell>ระดับคะแนนประเมินตนเอง ด้าน pd</HeaderCell>
                                  <Cell dataKey="levelPd" />
                                </Column>

                                <Column width={180} align="right">
                                  <HeaderCell>จำนวนครั้งที่เข้าร่วมอบรม</HeaderCell>
                                  <Cell dataKey="score" />
                                </Column>
                              </Table>
                            </Col>
                          </Row>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </Panel>
            </Col>
            <Col xs={24} sm={24} md={6} lg={6}>
              <Panel bordered collapsible defaultExpanded style={{ marginTop: 5 }} header={`  `}>
                {schema?.searchForms?.evaluation && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">
                        {schema?.searchForms?.evaluation?.label || ''}
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.evaluation.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckPicker
                                data={schema?.searchForms?.evaluation.options || []}
                                // value={props.value}
                                value={evaluation || []}
                                placeholder="เลือก"
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  setEvaluation(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.province && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">
                        {schema?.searchForms?.province?.label || ''}
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.province.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckPicker
                                data={schema?.searchForms?.province.options || []}
                                // value={props.value}
                                value={locationProvince || []}
                                placeholder="เลือก"
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  setLocationProvince(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.traningPd && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">
                        {schema?.searchForms?.traningPd?.label || ''}
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.traningPd.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckPicker
                                data={schema?.searchForms?.traningPd.options || []}
                                // value={props.value}
                                value={traningPd || []}
                                placeholder="เลือก"
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  setTraningPd(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.button && (
                  <Row className="filter-box">
                    {schema?.searchForms?.button?.search && (
                      <Col
                        xs={schema?.searchForms?.button?.search?.setCol.xxs}
                        sm={schema?.searchForms?.button?.search?.setCol.xsm}
                        md={schema?.searchForms?.button?.search?.setCol.xmd}
                        lg={schema?.searchForms?.button?.search?.setCol.xlg}
                      >
                        <SaveButton
                          icon={'search'}
                          block
                          children={schema?.searchForms?.button?.search?.label}
                          onClick={() => {
                            handleSearch()
                          }}
                        />
                      </Col>
                    )}

                    {schema?.searchForms?.button?.exportExcel && (
                      <Col
                        xs={schema?.searchForms?.button?.exportExcel?.setCol.xxs}
                        sm={schema?.searchForms?.button?.exportExcel?.setCol.xsm}
                        md={schema?.searchForms?.button?.exportExcel?.setCol.xmd}
                        lg={schema?.searchForms?.button?.exportExcel?.setCol.xlg}
                      >
                        <SaveButton
                          icon={'file-excel-o'}
                          block
                          children={schema?.searchForms?.button?.exportExcel?.label}
                          onClick={() => {
                            handleExportExcel()
                          }}
                        />
                      </Col>
                    )}

                    {schema?.searchForms?.button?.cancel && (
                      <Col
                        xs={schema?.searchForms?.button?.cancel?.setCol.xxs}
                        sm={schema?.searchForms?.button?.cancel?.setCol.xsm}
                        md={schema?.searchForms?.button?.cancel?.setCol.xmd}
                        lg={schema?.searchForms?.button?.cancel?.setCol.xlg}
                      >
                        <CancelButton
                          icon={'close-circle'}
                          block
                          children={schema?.searchForms?.button?.cancel?.label}
                          onClick={() => {
                            handleCancel()
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                )}
              </Panel>
            </Col>
          </Row>
        )}
      </div>
    </>
  )
}
